import { Environment } from './Environment';

import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';

export default class TranslationService {

  public getTranslations(environment: "Development" | "Test" | "Production", token: string, tenant: string, title: string, teaser: string, categories: string, text: string, to: string) {
    return new Promise((resolve) => {
      if (environment && tenant && token && title && text && to) {
        const body: string = JSON.stringify(
          {
            Texts: [title, categories ?? "", text ? text : '', teaser ? teaser : ''],
            TranslateTo: to
          }
        );

        return new FetchProxy(`${Environment.getEnvironmentForTranslationAPI(environment)}/${tenant}/translate`,
          {
            method: 'POST',
            headers: {
              'AuthToken': token,
              'Content-Type': 'application/json'
            },
            body: body
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw (response.status);
            } else {
              return response.json();
            }
          }).then(response => {
            const translation = [];
            response.forEach(translateText => {
              translation.push(translateText);
            });
            resolve(translation);
          }).catch((error) => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }

}